export default __webpack_public_path__ + "static/refer-property-mobile-1a8266692ac70a83bffcdf0ec701c7e6.png";